import useTranslate from 'app/i18n/useTranslate';

const useConstants = () => {
    const t = useTranslate('onboardingCurrentUserPage');

    return {
        FIRST_NAME_BODY_TEXT: t('firstNameBodyText'),
        FIRST_NAME_FOOTER_TEXT: t('firstNameFooterText'),
        FIRST_NAME_PLACEHOLDER: t('firstNamePlaceholder'),
        LAST_NAME_BODY_TEXT: t('lastNameBodyText'),
        LAST_NAME_FOOTER_TEXT: t('lastNameFooterText'),
        LAST_NAME_PLACEHOLDER: t('lastNamePlaceholder'),
        PHONE_BODY_TEXT: t('phoneBodyText'),
        PHONE_FOOTER_TEXT: t('phoneFooterText'),
        PHONE_PLACEHOLDER: t('phonePlaceholder'),
        WELCOME: t('welcome')
    };
};

export default useConstants;
